<template>
  <div>
    <v-btn
      icon
      class="mx-3 d-none m-notification-btn d-md-flex"
      @click="toggleDrawer"
      :class="
        $store.getters['ui/notifications'].unread > 99
          ? 'long-notification-text'
          : ''
      "
    >
      <v-badge
        v-if="$store.getters['ui/notifications'].unread != 0"
        md-and-up
        overlap
        color="#F3425C"
        :class="$store.getters['ui/notifications'].unread > 99 ? 'px-1' : ''"
      >
        <template v-slot:badge>
          <span class="overline font-weight-bold">{{
            $store.getters["ui/notifications"].unread > 99
              ? "99+"
              : $store.getters["ui/notifications"].unread
          }}</span>
        </template>
        <v-icon color="#616161" style="position: relative">
          mdi-bell-alert
        </v-icon>
      </v-badge>
      <v-icon v-else color="#616161"> mdi-bell-alert </v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  name: "MNotifcations",
  data() {
    return {};
  },
  methods: {
    toggleDrawer() {
      const drawer = this.$store.getters["ui/drawer"].right;
      this.$store.commit("ui/drawer.right", {
        component: "m-notification-drawer",
        show: !drawer.show,
        response: [],
      });
      this.mobileprofileMenuToggle = false;
    },
  },
};
</script>
